import React, { useEffect, useState } from 'react';
import './translator.css';

const Translator = ({ langRef }) => {
    const [dropdownReady, setDropdownReady] = useState(false);

    const addGoogleTranslateScript = () => {
        return new Promise((resolve) => {
            if (document.querySelector('script[src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"]')) {
                resolve();
                return;
            }

            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = '//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';
            script.async = true;
            script.onload = resolve;
            document.body.appendChild(script);
        });
    };

    useEffect(() => {
        window.googleTranslateElementInit = () => {
            new window.google.translate.TranslateElement(
                {
                    pageLanguage: 'it',
                    includedLanguages: 'it,en',
                    autoDisplay: false,
                },
                'google_translate_element'
            );

            const waitForDropdown = setInterval(() => {
                const selectBox = document.querySelector('#google_translate_element select');
                if (selectBox) {
                    setDropdownReady(true);
                    clearInterval(waitForDropdown);
                }
            }, 500);

            setTimeout(() => {
                if (!dropdownReady) {
                    console.error('Google Translate dropdown is still not ready.');
                    clearInterval(waitForDropdown);
                }
            }, 5000);
        };

        addGoogleTranslateScript().then(() => {
            console.log('Google Translate script loaded and initialized.');
        });
    }, [dropdownReady]);

    const handleLanguageChange = (event) => {
        if (!dropdownReady) {
            console.error('Google Translate dropdown is not ready yet.');
            return;
        }

        const language = event.target.value;
        const selectBox = document.querySelector('#google_translate_element select');
        if (selectBox) {
            selectBox.value = language;
            selectBox.dispatchEvent(new Event('change'));
        }
    };

    langRef.current = handleLanguageChange;

    return (
        <div>
            <div id="google_translate_element" style={{ display: 'none' }}></div>
            <style>{`
        #google_translate_element, .skiptranslate { display: none; }
        .goog-te-banner-frame { display: none !important; }
        body { top: 0 !important; }
      `}</style>
        </div>
    );
};

export default Translator;